module.exports = "<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->\n\n<span><input class=\"input-small\" /></span>\n";